import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import { SkillType, SkillTypeEnum } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { useSkillsFilterQuery } from './graphql/queries/generated/skillsFilter';

const getSkillFilterOption = ({ id, name }: Pick<SkillType, 'id' | 'name'>) => ({
  value: id,
  label: name,
});

const EDGE_KEY = 'skills';

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery: useSkillsFilterQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { ids: value, types: [SkillTypeEnum.Ability, SkillTypeEnum.Behavior] } },
    getFilterOption: getSkillFilterOption,
  });

const useSkillOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useSkillsFilterQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { searchText, types: [SkillTypeEnum.Ability] } },
    getFilterOption: getSkillFilterOption,
  });

const useMindsetOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery: useSkillsFilterQuery,
    edgeKey: EDGE_KEY,
    variables: { filters: { searchText, types: [SkillTypeEnum.Behavior] } },
    getFilterOption: getSkillFilterOption,
  });

export const SkillEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useSkillOptionsQuery,
  useFilterValues,
};

export const SkillSingleEntityConfig: FilterBodyListConfig = {
  listVariant: 'single-ungrouped-infinite',
  useOptionsQuery: useSkillOptionsQuery,
  useFilterValues,
};

export const MindsetEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useMindsetOptionsQuery,
  useFilterValues,
};

export const MindsetSingleEntityConfig: FilterBodyListConfig = {
  listVariant: 'single-ungrouped-infinite',
  useOptionsQuery: useMindsetOptionsQuery,
  useFilterValues,
};
